import store from "../store";
import axios from "axios";
import { afLogoutReducer } from "../store/afAuth.slice";

export const afClient = axios.create({
    baseURL: '/v1/'
});

export const client = axios.create({
    baseURL:   process.env.REACT_APP_SHOP_URL + '/v1/'
});

afClient.interceptors.request.use(
    config => {
        const state = store.getState();
        const sessionId = state?.afAuth?.afUserData?.sessionId;
        if (!!sessionId) config.headers['Sessionid'] = sessionId;
        return config;
    },
    error => Promise.reject(error)
);

afClient.interceptors.response.use(
    res => res,
    error => {
        if (error.response && error.response.status === 401){
            store.dispatch(afLogoutReducer());
        }
        return Promise.reject(error)
    }
)

export const api = data => client(data)
    .then(res => res.data )
    .catch(err => { throw new Error(err?.response?.data?.errorMsg ?? err); });

export const afApi = data => afClient(data)
    .then(res => res.data )
    .catch(err => { throw new Error(err?.response?.data?.errorMsg ?? err); });

export const afApiWithSession = data => afClient(data)
    .then(res => ({ ...res.data, sessionId: res.headers.sessionid }))
    .catch(err => { throw new Error(err?.response?.data?.errorMsg ?? err); });

export const afLogin = data => afApiWithSession({
    method:'post',
    url:'login',
    data,
    validateStatus: status => status >= 200 && status < 400,
});

export const otpApi = (data) => afApiWithSession({
    method:'post',
    url:`login/otp`,
    data
})

export const afDashboard = url => afApi({
    method:'get',
    url
})

export const getCountries = () => client({ method: 'get', url: `countries` })
    .then((res) => ({ data: res.data, ipcountry: res.headers['x-cf-ipcountry'] }))
    .catch((err) => { throw new Error(err?.response?.data?.errorMsg ?? "GNRMSG-07"); });


    export const resetPassword = ({ passwordResetUUID, password }) => afApi({
        method: 'put',
        url: `resetpassword`,
        data: {
            passwordResetUUID,
            password
        }
    })

export const signUpAPI = data => afApi({
    method: 'post',
    url:'signup',
    data
});
export const verifyEmail =  data => afApi({
    method: 'post',
    url:`verifyemail`,
    data
});

export const forgotPassword = (email) => afApi({
    method: 'get',
    url: `forgotpassword?email=${encodeURIComponent(email)}`
})

export const getBatchList = (req) => afApi({
    method: 'get',
    url: `vouchers?${req}`
})

export const searchPrepaidVoucherApi =(url)=> afApi({
    method:'get',
    url:`bundles?${url}`
})

export const createBatch = (data) => afApi({
    method:'post',
    url:`vouchers`,
    data
})

export const shareEmail = (email, id) => afApi({
    method:'post',
    url:`/vouchers/${id}/share`,
    data: { email }
})

export const getBatchInfo = (req) => afApi({
    method: 'get',
    url: `vouchers?batchId=${req.id}`
})

export const getBatchStatus = (req) => {
    return afApi({
      method: 'put',
      url: `vouchers`,
      data: req,
    });
  };
  
export const getVoucherStatus = (req) => {
    return afApi({
        method: 'put',
        url: `vouchers/${req.id}`,
        data: req.payload,
    });
};
  

export const languageGetApi = (ln,screen) => api({method:'get', url:`assets?language=${ln}&screen=${screen}`})
